<template>
    <article :class="practiceDetailsCard">
        <div class="user-details-card__info">
            <div class="user-details-card__avatar">
                <common-ancillary-avatar
                    v-if="practice"
                    :ancillary="practice"
                    :type="type"
                    size="user-menu"
                ></common-ancillary-avatar>
            </div>

            <div>
                <p v-if="topText" class="user-details-card__dark">
                    {{ topText }}
                </p>

                <p class="user-details-card__name">
                    {{ practice?.name }}
                    <!-- <common-user-name :user="practice"></common-user-name> -->
                </p>

                <p v-if="bottomText">
                    {{ bottomText }}
                </p>

                <p v-if="bottomText2">
                    {{ bottomText2 }}
                </p>

                <slot></slot>
            </div>
        </div>
    </article>
</template>

<script>
    export default {
        props: {
            practice: { type: Object, required: true },
            topText: { type: String, default: null },
            bottomText: { type: String, default: null },
            bottomText2: { type: String, default: null },
            size: { type: String, default: 'medium' },
            alignContactDetails: { type: String, default: 'left' },
            type: { type: String, default: 'primary' },
        },

        computed: {
            practiceDetailsCard() {
                return {
                    'user-details-card': true,
                    [`user-details-card--size-${this.size}`]: true,
                }
            },

            contactClass() {
                return {
                    [`user-details-card__contact--size-${this.size}`]: true,
                    [`user-details-card__contact--align-${this.alignContactDetails}`]: true,
                }
            },
        },
    }
</script>
